import { isStaffRole, type Role } from '@pazportal/types';

/** Resolve staff authority only from a current server profile, never cached claims. */
export function staffRoleFromProfile(profile: { role?: unknown } | null): Role | null {
  return typeof profile?.role === 'string' && isStaffRole(profile.role) ? profile.role : null;
}
